module.exports = __webpack_public_path__ + "static/img/application_1.3942011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/application_1.png
// module id = 0N8X
// module chunks = 1